import React, { Component } from 'react';
import ProductImage from './ProductImage';
import { genImageAlt } from '../../helpers';
import { Product } from '../../common/models/Store/api/Products';
import { ResponsivenessConfig } from '../../components/ResponsiveImg/StyledResponsiveImg';

interface ProductImageCardInnerProps {
  cart?: boolean;
  height?: string;
  images?: string[];
  padTop?: string;
  placeholderHeight?: string;
  placeholderWidth?: string;
  product: Product;
  responsivenessConfig: ResponsivenessConfig;
  s3BasePath: string;
  width?: string;
}

interface ProductImageCardInnerState {
  currentImage?: 0 | 1;
}

const handleSmallImage = e => {
  if (e.target.height < 200) {
    const newStyles = `
    `;
    e.target.setAttribute('style', newStyles);
  }
};

class ProductImageCardInner extends Component<ProductImageCardInnerProps, ProductImageCardInnerState> {
  constructor(props) {
    super(props);
    this.state = { currentImage: 0 };
  }

  handleMouseEnter = () => {
    const { images } = this.props;
    if (images && images[1]) {
      this.setState({ currentImage: 1 });
    }
  };

  handleMouseLeave = () => {
    const { images } = this.props;
    if (images && images.length > 0) {
      this.setState({ currentImage: 0 });
    }
  };

  unpackImage = (imageSrc: string, idx: number) => {
    const {
      cart,
      padTop,
      s3BasePath,
      width,
      height,
      product,
      placeholderWidth,
      placeholderHeight,
      responsivenessConfig,
    } = this.props;

    const { currentImage } = this.state;

    return (
      <ProductImage
        alt={product ? genImageAlt(product.model, product.brand, product.color) : null}
        data-cy="image-product"
        display={currentImage !== idx ? 'none' : undefined}
        height={height}
        minHeight={placeholderHeight}
        minWidth={placeholderWidth}
        onError={e => {
          (e.target as HTMLImageElement).src = `${s3BasePath}mkt/icon/no_image.png`;
        }}
        onLoad={e => (cart ? undefined : handleSmallImage(e))}
        padTop={padTop}
        responsivenessConfig={responsivenessConfig}
        src={imageSrc}
        width={width}
      />
    );
  };

  render = () => {
    const { images } = this.props;

    return (
      <div onMouseEnter={() => this.handleMouseEnter()} onMouseLeave={() => this.handleMouseLeave()}>
        {images.map((imageSrc, idx) => this.unpackImage(imageSrc, idx))}
      </div>
    );
  };
}

export default ProductImageCardInner;
